import { render, staticRenderFns } from "./paddingheader.vue?vue&type=template&id=efa5bb46&scoped=true&"
var script = {}
import style0 from "./paddingheader.vue?vue&type=style&index=0&id=efa5bb46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa5bb46",
  null
  
)

export default component.exports